import React, { Component } from "react";
import "react-bootstrap";

import store from "../../store/configureStore";
import SearchBlock from "./SearchBlock";
import { lang } from "../../config/lang";
import { connect } from "react-redux";
import { addNotification } from "../../actions/notificationAction";
import {
  changeTopBannerAction,
  setSearchKeyAction,
} from "../../actions/topBannerAction";
import { changeActiveItemAction } from "../../actions/navAction";
import { Businesses, PagesForCaption, CaptionCodes } from "../../config/Helper";
import Pagination from "../../components/pagination/Pagination";
import { useEffect, useRef, useState } from "react";
import searchApi from "../../api/searchApi";
import { withRouter } from "react-router-dom";
import NoData from "../../components/NoData";
import { setGlobalSearchKeyAction } from "../../actions/searchAction";
/****************************************
    Component for special page
    @author  UYM
    @date    2020.05.15
    @version 0.1    
 ******************************************/
const SearchList = (props, { router, handleDone }) => {
  // const keyword = store.getState().topBanner.searchKey;

  const keyword = decodeURIComponent(props.location.search.split("=")[1]);

  const bs = "all";
  const category = "all";
  const paginate = {
    currentPage: 1,
    lastPage: 1,
    visible: 6,
  };
  const [total, setTotal] = useState(0);
  const [searchData, setSearchData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  useEffect(() => {
    if (!keyword) {
      setSearchData([]);
      setLastPage(0);
      setTotal(0);
      // props.history.push("/home");
      return;
    }
    store.dispatch(setGlobalSearchKeyAction(keyword));
    // else
    searchApi.paginate(currentPage, bs, category, keyword).then((json) => {
      if (json.status === 200) {
        paginate.lastPage = json.data.lastPage;
        const searchData = Array.isArray(json.data.data) ? json.data.data : [];
        setSearchData(searchData);
        setLastPage(json.data.lastPage);
        setTotal(json.data.total);
      } else {
        store.dispatch(addNotification("Server error", "error"));
      }
    });

    window.onSetClass("dark");
    window.scrollTop("#top_banner");
    store.dispatch(changeActiveItemAction(Businesses.indexOf("search")));
    store.dispatch(
      changeTopBannerAction({
        page: "",
        showSearch: false,
        isHome: false,
        globalSearch: true,
      })
    );
    store.dispatch(setSearchKeyAction(keyword));
  }, [keyword, currentPage, props.language.lang_key]);
  useEffect(() => {
    setCurrentPage(1);
  }, [keyword]);
  function onChangePage(page) {
    setCurrentPage(page);
  }
  const detectFileFormat = (data) => {
    if (data.media_filetype === null) return "text";
    if (data.format == "0") return "image";
    if (data.format == "1") return "video";
  };
  return (
    <>
      <div className="container ftco-animate fadeIn ftco-animated">
        <div className="row">
          <div className="col-md-12 mb-5 search-list">
            <div className="mt-3 mb-3">{`${lang("total")}` + total}</div>
            <hr className="solid tall" />
            {searchData &&
              searchData.map((singleArticle, key) => (
                <SearchBlock
                  key={key}
                  pKey={12 * currentPage + key - 11}
                  business={
                    singleArticle.business ? singleArticle.business : 20
                  }
                  id={
                    singleArticle.business_id
                      ? singleArticle.business_id
                      : singleArticle.id
                  }
                  title={singleArticle.title}
                  date={singleArticle.updated_at}
                  images={singleArticle.medias}
                  keyword={keyword}
                  total={total}
                  type={detectFileFormat(singleArticle)}
                />
              ))}
            {searchData && searchData.length === 0 && <NoData />}
          </div>
        </div>
        <hr className="solid tall" />
        <section className="select-selection">
          <div className="container">
            <div className="row justify-content-center pb-5">
              <div className="block-27">
                {searchData && searchData.length > 0 && (
                  <Pagination
                    total={lastPage}
                    curPage={currentPage}
                    visible={paginate.visible}
                    onChangePage={onChangePage}
                  />
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
function mapStateToProps(state) {
  return {
    language: state.language,
  };
}

export default connect(mapStateToProps)(SearchList);
